<ng-container *ngIf="quarterlyOutcomesLists?.length; else noQuarteralyOutcomes">
  <div
    class="quarterly-outcome-wrapper no-quartely-table"
    *ngFor="let list of quarterlyOutcomesLists"
  >
    <div class="details dis-flex flex-sb">
      <div class="left-side dis-flex flex-col">
        <div class="tags m-b-15 dis-flex">
          <p-chip
            *ngIf="!isWorkPackage"
            class="b3 radius-8 m-r-20"
            [label]="list?.tagged"
          />
          <p-chip
            class="b3 radius-8"
            [label]="'Cycle ' + list?.quarter + ', ' + list?.year"
          />
          <p-divider class="vertical-divider" layout="vertical" />
          <p-chip
            class="b3 radius-8 status-chip not-started"
            *ngIf="list?.status == '0'"
            label="Not started"
          />
          <p-chip
            class="b3 radius-8 status-chip not-started"
            *ngIf="list?.status == '1'"
            label="Not started"
          />
          <p-chip
            class="b3 radius-8 status-chip ongoing"
            *ngIf="list?.status == '2'"
            label="Ongoing"
          />
          <p-chip
            class="b3 radius-8 status-chip completed"
            *ngIf="list?.status == '3'"
            [label]="'Completed'"
          />
          <p-chip
            class="b3 radius-8 status-chip delayed"
            *ngIf="list?.status == '4'"
            label="Delayed"
          />
          <p-chip
            class="b3 radius-8 status-chip terminated"
            *ngIf="list?.status == '5'"
            label="Terminated"
          />
        </div>
        <div class="content-title dis-flex flex-m">
          <p-avatar label="STO" class="outcome-type m-r-10 p-avatar-square" />
          <p class="b1 m-b-0 text-80">
            {{ list?.value }}
          </p>
        </div>
        <app-milestone-status-count
          [quarterlyOutcomesList]="list"
        ></app-milestone-status-count>
      </div>
      <div
        class="right-side dis-flex flex-col flex-sb"
        *ngIf="list?.status != '5'"
      >
        <div
          class="action-items dis-flex flex-r quarterly-outcome-items text-right"
        >
          <div class="dis-flex m-r-30" *ngIf="list?.is_migrated == '1'">
            <p-chip class="b3 radius-8 status-chip migrated" label="Migrated" />
          </div>
          <div
            class="dis-flex"
            *ngIf="!(list?.timeline?.plan_end | isPlanningPhase)"
          >
            <div class="">
              <p
                class="b3 text-error m-b-0 lh-2-0"
                ngbTooltip="Updation is restricted in Implementation Phase"
              >
                <ng-icon
                  class="lh-2-2 icon-hover-primary pointer-cursor"
                  name="hugeMessage02"
                  size="24"
                />
              </p>
            </div>
          </div>
          <button
            class="icon-only-btn m-l-15"
            [ngbPopover]="actionItemsMenu"
            *ngIf="
              (list?.timeline?.plan_end | isPlanningPhase) &&
              (list?.accountable | canViewActionItem)
            "
          >
            <ng-icon
              class="icon-hover-primary"
              ngbTooltip="Action Items"
              name="hugeMoreVerticalCircle01"
            />
          </button>
          <ng-template #actionItemsMenu>
            <div class="action-item-list">
              <a
                (click)="openWizard(list)"
                role="button"
                class="dis-flex p-t-12 p-b-12 p-l-20 p-r-20 trans-0-4"
              >
                <ng-icon class="text-80 lh-1-0" name="hugeAdd01" size="18" />
                <span class="b2 text-80 m-l-10">Add Milestones</span>
              </a>
              <a
                type="button"
                class="dis-flex p-t-12 p-b-12 p-l-20 p-r-20 trans-0-4"
                (click)="tagWP(list)"
              >
                <ng-icon class="text-80 lh-1-0" name="hugeTag01" size="18" />
                <span class="b2 text-80 m-l-10">Tag STO</span>
              </a>
              <a
                (click)="openTerminateModal(list)"
                type="button"
                class="dis-flex danger-action-item p-t-12 p-b-12 p-l-20 p-r-20 trans-0-4"
              >
                <ng-icon class="text-80 lh-1-0" name="hugeDelete02" size="18" />
                <span class="b2 text-80 m-l-10">Mark as Terminated</span>
              </a>
            </div>
          </ng-template>
        </div>
        <div class="created-by text-right">
          <p class="caption text-60 font-medium m-b-0">Accountable</p>
          <p-avatar
            [ngbTooltip]="list?.user?.name"
            [image]="list?.user?.avatar || getDefaultAvatar()"
            shape="circle"
          />
        </div>
      </div>
    </div>

    <app-milestone
      *ngFor="let milestoneList of list?.milestones"
      [milestoneList]="milestoneList"
      [outcomeTitle]="list?.value"
      [isMyTask]="isMytask"
      [timeline]="list?.timeline"
      (notifyParent)="handleChildEvent($event)"
    ></app-milestone>
  </div>

  <p-dialog
    header="Terminate ?"
    class="action-item-modal b1 font-medium"
    [modal]="true"
    [(visible)]="isOpenTerminateModal"
    [style]="{ width: '30rem' }"
  >
    <div class="wrapper p-l-20 p-r-20 p-t-25 p-b-25">
      <div class="dis-flex flex-col">
        <p class="b2 m-b-0 text-70">
          Are you sure, you want
          <span class="font-medium text-80"
            >Terminate the {{ isAnnual ? "MTO" : "STO" }}</span
          >
          ?
        </p>
      </div>
    </div>
    <div class="button-group dis-flex flex-r m-t-20 m-b-20 m-r-15">
      <button
        class="btn outline wd-100px m-r-10"
        (click)="closeTerminateModal()"
      >
        No
      </button>
      <button class="btn primary wd-100px" (click)="terminateOutcome()">
        Yes
      </button>
    </div>
  </p-dialog>

  <!-- Tag Work Package Modal -->
  <p-dialog
    *ngIf="quarterlyOutcomesLists?.length"
    header="Tag STO"
    class="action-item-modal b1 font-medium"
    [modal]="true"
    [(visible)]="visible"
    [style]="{ width: '50rem' }"
  >
    <form [formGroup]="workForm" (ngSubmit)="onSubmit()">
      <div class="wrapper p-l-20 p-r-20 p-t-25 p-b-50">
        <div class="dis-flex gap-3">
          <div class="dis-flex flex-col wd-50">
            <label for="username" class="b2 font-medium m-b-5 text-80"
              >Type of Work</label
            >
            <p-dropdown
              [options]="TypesOfWork"
              (onChange)="onTypeChange($event)"
              optionLabel="label"
              placeholder="Select"
              [overlayOptions]="helper.getOverlayOptions()"
            >
            </p-dropdown>
          </div>
          <div
            class="dis-flex flex-col wd-50"
            *ngIf="workForm.get('type')?.value == 'Work Package'"
          >
            <label for="email" class="b2 font-medium m-b-5 text-80"
              >Work Package</label
            >
            <p-dropdown
              (onChange)="onWorkPkgChange($event)"
              optionLabel="name"
              filter="true"
              (onFilter)="onWPSearchList($event)"
              [options]="workPkgLists"
              placeholder="Select"
              [overlayOptions]="helper.getOverlayOptions()"
            />
          </div>
        </div>
      </div>
      <div class="button-group dis-flex flex-r m-t-20 m-b-20 m-r-15">
        <button
          class="btn outline wd-100px m-r-10"
          (click)="closeTaggedModal()"
        >
          Cancel
        </button>
        <button class="btn primary wd-100px" (submit)="onSubmit()">
          Update
        </button>
      </div>
    </form>
  </p-dialog>
</ng-container>
<ng-template #noQuarteralyOutcomes>
  <div>
    <app-loader *ngIf="isLoading; else noOutcomes"></app-loader>
    <ng-template #noOutcomes>
      <p class="no-quartely-table">No Short Term Outcomes available.</p>
    </ng-template>
  </div>
</ng-template>
